module.exports = __webpack_public_path__ + "6b854ea02875824a3f6a6e93b00c4b0b.png";